<template lang="pug">
validation-observer.analise(ref='validation' tag='div')
  div.analise(v-if="despacho !== null")
    app-analise-header(
      :id-processo="despacho.processo.id",
      v-if="despacho.processo !== null"
      :numero-processo="isBahia ? '' : despacho.processo.numeroProcesso",
      :statusProcesso="despacho.processo.status"
      :titulo-analise="tipoEmissao"
      :tipo="typeof despacho.processo.tipo === 'object' ? despacho.processo.tipo.codigo : despacho.processo.tipo",
      :numeroProtocolo="despacho.processo.numeroProtocolo",
      :show-separate="true"
      :show-messages='true',
      :opcoesHeader="true",
      :btnSolicitarInformacao="true",
      :btnSolicitarRetificacao="!isRetificacaoTitulo"
      :btnNotificarInteressado="!isRetificacaoTitulo"
      :idDespacho="despacho.id",
      :isEmissaoCertidao="isEmissaoCertidao"
    )
      template(slot="separate")
        el-card(shadow="hover").card-collapse
          app-despachos(
            :idProcesso="idProcesso",
            :data="dadosCadastro",
            @getDownload="getDownload",
          )
      template(slot="analise")
        el-steps.extra-margin-top-bottom(:active='active', finish-status='success', simple)
          el-step(title='Informar dados')
          el-step(title='Edição de Título' v-if="isMaranhao")
          el-step(title='Confirmar dados' v-if="!isCertidao")

        div(v-if="active === 0")
          app-radios-tramitacao(
            v-if="((isTitulo && !isReurb && !isCertidaoOrTitulo && !isNovaPortaria) || (isCertidaoOrTitulo)) && acaoParaEmissao",
            :radios="acaoParaEmissao",
            :isDecisao="true",
            @changeRadio="changeRadioDespacho",
            :radioInicial="action",
          )
          app-cadastra-titulo-certidao(
            v-if="showTitulo && !isRevisao && !isRetorno"
            ref='formulario',
            :despacho='despacho'
          )
          div(v-if="isRevisao || isRetorno")
            validation-provider(rules="required", v-slot="{ errors }")
              app-label.input-text-editor(label="Despacho")
              app-editor-texto.input(
                @onTextChange="onTextChange",
                v-model="despacho.textoDespacho",
                :class="{'erro' : errors.length}"
                ref="editorTexto"
              )
              span.help.erro {{ errors[0] }}
            app-anexo(
              :id="'upload-anexo-despacho'",
              @uploadFile="uploadFile",
              :files="this.filtrarDocumentosSemAssinaturaSimbolicaMa()",
              @removeFile="removeFile"
              @downloadDocumentoCadastro="downloadDocumentoCadastro",
              :tipoExibir="'ANEXO_ANALISE'"
            )
          el-card(v-if="isArquivamentoIndeferimento && !isAmapa && !isReurbIndividual && !isPara")
            app-label(
              label="Inclua a Carta de Notificação ao Interessado"
              :required="isValidateCarta !== ''"
            )
            validation-provider(:rules="isValidateCarta", v-slot="{ errors }")
              app-anexo(
                :id="'upload-carta-notificacao'"
                @uploadFile="uploadCartaNotificacao",
                :files="cartas",
                @removeFile="removeCartaNotificacao",
                :showAnexar="true"
                :errors="errors"
                @downloadDocumentoCadastro="getDownload",
                :tiposArquivosPermitidos="tiposArquivosPermitidosMapas"
                v-model="cartas"
                :showUpload="cartas.length === 0"
              )

        div.margin(v-else-if="active === (isMaranhao ? 2 : 1) && !isRevisao && !isRetorno")
          app-pdf-viewer(
            v-if="bytes"
            :bytes = "bytes"
          )
        div(v-if="(active === (isMaranhao ? 2 : 1)) && (isRevisao || isRetorno)")
          validation-provider(rules="required", v-slot="{ errors }")
            app-label.input-text-editor(label="Despacho")
            app-editor-texto.input(
              @onTextChange="onTextChange",
              v-model="despacho.textoDespacho",
              :class="{'erro' : errors.length}"
              ref="editorTexto"
            )
            span.help.erro {{ errors[0] }}
        div(v-else-if="active === 1 && isMaranhao && !isRevisao && !isRetorno")
          validation-provider(rules="required", v-slot="{ errors }")
            field-app-text-area(
              :formOptions="formOptions",
              :model="modelTexto",
              :schema="schema",
            )
          div(v-if="!isRetificacaoTitulo")
            p.labelAssinatura Assinaturas:&nbsp
            app-anexo(
              :files="imagensAssinaturas"
              :id="'upload-assinaturas'"
              :tipoExibir="'ANEXO_ANALISE'"
              :fileType="['png', 'jpg', 'jpeg']"
              @uploadFile="uploadAssinatura",
              @downloadDocumentoCadastro="downloadDocumentoCadastro",
              @removeFile="removeAssinatura"
            )
        div(v-if="(active === getTelaFinal || isRevisao || (isRetorno && isMaranhao))")
          validation-observer.flex-around(ref='validationTitulo' tag='div')
            app-radios-tramitacao(
              :radios="getAcoes",
              :isDecisao="isDecisao",
              @changeRadio="changeRadio",
              :radioInicial="despacho.acao",
            )
        app-buttons-cadastro(
          :isPrimeiroPasso="active === 0",
          :isUltimoPasso="(!isMaranhao ? active === 1 : ([2].includes(active))) || isRevisao || isRetorno",
          :showButtonSalvar="(!isMaranhao ? active === 0 : ([0,1].includes(active))) && !isRevisao && !isRetorno",
          :showButtonDownload="(!isMaranhao ? active === 1 : ([2].includes(active)))",
          :showButtonCancelar="(!isMaranhao ? active === 0 : ([0,1].includes(active)))",
          :showButtonFinalizar="(!isMaranhao ? active === 1 : ([2].includes(active))) || isRevisao || isRetorno"
          :showButtonProximo="(!isMaranhao ? active === 0 : ([0,1].includes(active))) && !isRevisao && !isCertidao && !isRetorno"
          @proximo="proximo",
          @salvar="salvarTituloCertidao",
          @voltar="voltar",
          @finalizar="finalizar",
          @download="downloadPdf",
          @cancelar="cancelar"
        )
</template>

<script>
import axios from '@/utils/api'
import FileSaver from 'file-saver'
import AppAnaliseHeader from './components/shared/AppAnaliseHeader'
import acaoProcesso from '@/constants/acaoProcesso'
import AppPdfViewer from '@/components/AppPDFViewerOld'
import AppEditorTexto from '@/components/AppEditorTexto'
import AppCadastraTituloCertidao from '@/screens/analise/components/AppCadastraTituloCertidao'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import FileHelper from '@/utils/fileHelper'
import AppDespachos from '@/components/AppDespachos'
import AppRadiosTramitacao from '@/components/AppRadiosTramitacao'
import AppLabel from '@/components/AppLabel'
import AppAnexo from '@/components/AppAnexo'
import AppButtonsCadastro from '@/components/AppButtonsCadastro.vue'
import { mapActions } from 'vuex'
const { messages, isTitulo, acoesRetornarRevisao, tiposCadatrosSemRevisao,
  acaoEmissao, acaoEmissaoCertidao, telaFinal,
  getMensagemEncaminhamentoTitulo, getAcao } = require('@/utils/' +
  process.env.ESTADO +
  '/regrasAnalise').default

export default {
  props: {
    idProcesso: {
      type: [Number, String]
    },
    despachoEdicao: {
      type: Object
    },
    tipo: {
      type: String,
      default: acaoProcesso.EMITIR_TITULO
    },
    urlOrigem: {
      type: String,
      default: 'CAIXA_ENTRADA'
    }
  },

  mixins: [AppNotificacao],

  components: {
    AppAnaliseHeader,
    AppPdfViewer,
    AppCadastraTituloCertidao,
    AppDespachos,
    AppRadiosTramitacao,
    AppEditorTexto,
    AppLabel,
    AppAnexo,
    AppButtonsCadastro
  },

  data () {
    return {
      active: 0,
      arrayBufferToBase64: null,
      despacho: null,
      tipoEmissao: '',
      cartas: [],
      imagensAssinaturas: [],
      tiposArquivosPermitidosMapas: '.png, .jpg, .jpeg, .pdf, .doc, .docx',
      dadosCadastro: null,
      showTitulo: false,
      modelTexto: {
        textoTitulo: ''
      },
      isDecisao: false,
      acoesRadio: [],
      radios: [],
      mensagemConfirmacao: {
        AGUARDANDO_CONFERENCIA_TITULO: 'Título emitido com sucesso!',
        ENCAMINHAR_REVISAO_PORTARIA: 'Solicitação enviada com sucesso!',
        FINALIZAR: 'Título emitido com sucesso!',
        ENCAMINHAMENTO: 'Processo encaminhado para a CAF!',
        ENCAMINHAMENTO_ERRATA_TITULO_CANCELADA: 'Errata cancelada. Processo enviado para o setor DATGL.',
        ENCAMINHAMENTO_ERRATA_TITULO_ASSINATURA: 'Análise finalizada. Processo enviado para o setor DRF.',
        ENCAMINHAR: 'Processo encaminhado para a CAF!',
        SOLICITAR_ARQUIVAMENTO: 'Processo encaminhado para DRF!',
        RETORNA_GEO: 'Processo retornado para a GEO.',
        TITULO_REVISADO: 'Processo enviado para assinatura do título.'
      },
      acaoEmissao: acaoEmissao,
      action: 'EMITIR',
      isTitulo: isTitulo,
      acoesRetornarRevisao: acoesRetornarRevisao,
      acaoEmissaoCertidao: acaoEmissaoCertidao,
      tiposCadatrosSemRevisao: tiposCadatrosSemRevisao,
      getAcao: getAcao
    }
  },

  async mounted () {
    await this.iniciaEmissao()
    this.tipoDeTitulo()
    this.showTitulo = true
  },

  computed: {
    getTelaFinal () {
      return telaFinal
    },
    isRoraima () {
      return process.env.ESTADO === 'rr'
    },
    isBahia () {
      return process.env.ESTADO === 'ba'
    },
    isAmapa () {
      return process.env.ESTADO === 'ap'
    },
    isPara () {
      return process.env.ESTADO === 'pa'
    },
    isRondonia () {
      return process.env.ESTADO === 'ro'
    },
    formOptions () {
      return {
        tipoModelo: 3,
        title: 'Emissão de Título',
        despacho: {
          ...this.despacho,
          idProcesso: this.idProcesso
        }
      }
    },
    schema () {
      return {
        inputName: 'textoTitulo'
      }
    },
    isMaranhao () {
      return process.env.ESTADO === 'ma'
    },
    isRevisao () {
      return this.action === 'REVISAO'
    },
    isRetorno () {
      return this.action === 'RETORNO'
    },
    getAcoes () {
      if (this.isMaranhao) {
        if (this.isRetificacaoTitulo) {
          if (this.action === 'EMITIR') {
            return this.acoesRadio.filter(a => !a.valor.includes('CANCELAR'))
          } else {
            return this.acoesRadio.filter(a => !a.valor.includes('FINALIZAR'))
          }
        }
        if (this.despacho.processo.tipo.codigo === 'TQ') {
          return this.acoesRadio.filter(
            action => action.valor !== 'ENCAMINHAMENTO.SISTEMA.CAF_REVISAO'
          )
        }
        return this.acoesRadio.filter(action => (this.isRevisao || this.isRetorno)
          ? this.acoesRetornarRevisao.includes(action.valor)
          : !this.acoesRetornarRevisao.includes(action.valor)
        )
      }
      if (this.isPara && this.active === 1) {
        return this.acoesRadio.filter(action => action.valor !== 'RETORNA_GEO.SISTEMA.GEO.AUTOCOMPLETE.ENCAMINHAMENTO' &&
      action.valor !== 'AGUARDANDO_ANALISE.ADM_S1.GP.AUTOCOMPLETE.SOLICITAR_REVISAO' &&
      action.valor !== 'AGUARDANDO.SISTEMA.GEO.AUTOCOMPLETE' &&
      action.valor !== 'ENCAMINHAR_REVISAO_PORTARIA.SISTEMA.GIT_CDI.ENCAMINHAMENTO.AUTOCOMPLETE')
      }
      if (this.isRondonia) {
        return this.acoesRadio
      }
      if (this.isAmapa) {
        return this.getAcao(this.despacho, this.acoesRadio, this.action)
      }
      if (this.despacho.processo.tipo.codigo === 'TEQ' && this.action === 'EMITIR' && this.tipo === 'EMITIR_TITULO') {
        return this.acoesRadio.filter(
          action => action.valor.includes('CONFERENCIA')
        )
      }
      return this.acoesRadio
    },
    isReurb () {
      return this.despacho.processo.tipo.codigo === 'REGULARIZACAO_URBANA'
    },
    isEmissaoTitulo () {
      return this.despacho.processo.status === 'EM_EMISSAO_TITULO' &&
        (this.despacho.processo.tipo.codigo === 'NAO_ONEROSO' || this.despacho.processo.tipo.codigo === 'ONEROSO')
    },
    isRetornoGpOuRevogacaoPortaria () {
      return this.despacho.processo.status === 'EM_EMISSAO_TITULO' &&
      this.action === 'REVISAO' &&
      (this.despacho.processo.tipo.codigo === 'NAO_ONEROSO' || this.despacho.processo.tipo.codigo === 'ONEROSO')
    },
    isReurbIndividual () {
      return ['REURB_INDIVIDUAL'].includes(this.despacho?.processo?.tipo?.codigo)
    },
    isCertidaoOrTitulo () {
      return this.despacho.processo.tipo.codigo === 'CERTIDAO_TITULO' || this.despacho.tipo === 'TITULO_CERTIDAO'
    },
    isConferenciaTitulo () {
      return this.despacho.tipo === 'CONFERIR_TITULO'
    },
    isCertidao () {
      return this.despacho.processo.tipo.codigo === 'CERTIDAO_TITULO'
    },
    isEmissaoCertidao () {
      return this.despacho.processo.status.includes('CERTIDAO') || this.despacho.processo.status.includes('CONFERENCIA')
    },
    acaoParaEmissao () {
      if (this.isRoraima) {
        return this.acaoEmissao.filter(action => !action.valor.includes('REVISAO'))
      }
      if (this.despacho.processo.tipo.codigo === 'CERTIDAO_TITULO') {
        return this.acaoEmissaoCertidao
      } else if (
        this.despacho.processo.tipo.codigo === 'ONEROSO' || this.despacho.processo.tipo.codigo === 'NAO_ONEROSO' ||
        this.despacho.processo.tipo.codigo === 'REGULARIZACAO_URBANA' || this.despacho.processo.tipo.codigo === 'PEAEX' ||
        this.despacho.processo.tipo.codigo === 'TEQ' || this.despacho.processo.tipo.codigo === 'PEAS'
      ) {
        return this.acaoEmissao
      } else {
        return this.acaoEmissao.filter(action => !action.valor.includes('REVISAO'))
      }
    },
    isNovaPortaria () {
      return this.despacho?.tituloDespacho?.tituloProcessoDTO?.novaPortaria
    },
    isRetificacaoTitulo () {
      return this.tipo === 'RETIFICAR_TITULO'
    },
    isArquivamentoIndeferimento () {
      return this.despacho?.acao?.includes('ARQUIVAMENTO') && !this?.dadosCadastros?.despacho?.acao?.includes('DESARQUIVAMENTO')
    },
    isValidateCarta () {
      return this.cartas?.length === 0 ? 'required' : ''
    }
  },

  methods: {
    ...mapActions({
      iniciaAnalise: 'processo/iniciaAnalise',
      salvar: 'despacho/salvar',
      getDespachoWithJsonTitulo: 'despacho/getDespachoWithJsonTitulo',
      finalizarDespacho: 'despacho/finalizar',
      getArrayTituloByDespachoId: 'despacho/getArrayTituloByDespachoId',
      getArrayRetificacaoTituloByDespachoId: 'despacho/getArrayRetificacaoTituloByDespachoId',
      tarefa: 'processo/tarefa',
      findById: 'despacho/findById',
      editarTituloCertidao: 'despacho/editarTituloCertidao',
      criarNovaCertidao: 'despacho/criarNovaCertidao'
    }),

    async salvarTituloCertidao () {
      var despacho = this.isMaranhao ? this.despacho = this.active === 0 ? this.$refs.formulario.$refs.tituloCertidao.save() : this.despacho : this.$refs.formulario.$refs.tituloCertidao.salvarDespacho()
      if (this.isCertidao) {
        const valido = await this.$refs.formulario.$refs.tituloCertidao.validate()
        if (!valido) {
          this.showNotificacao(
            this.$messages.TIPO_WARNING,
            this.$messages.TITULO_WARNING,
            this.$messages.ERROS_ANALISE
          )
          return
        }
      }
      if (despacho) {
        if (this.despachoEdicao && this.isCertidao) {
          try {
            await this.editarTituloCertidao(despacho)
            this.showNotificacao(
              this.$messages.TIPO_SUCCESS,
              this.$messages.TITULO_SUCCESS,
              `${messages.headerTituloCertidao} editado com Sucesso.`
            )
            if (this.isArquivamentoIndeferimento) {
              this.setCartaNotificacaoInteressado()
              this.cartas = []
            }
            this.$router.push({
              name: 'conferencia-certidao',
              params: {
                idProcesso: this.idProcesso,
                tipoDespacho: this.despachoEdicao.tipo,
                idTitulo: this.despachoEdicao.id
              }
            })
          } catch (error) {
            this.showNotificacao(
              this.$messages.TIPO_ERROR,
              this.$messages.TITULO_ERROR,
              `Erro ao editar o ${messages.headerTituloCertidao}, contate o administrador do sistema.`
            )
          }
        } else if (this.isCertidao) {
          this.criarNovaCertidao(despacho)
            .then(() => {
              this.showNotificacao(
                this.$messages.TIPO_SUCCESS,
                this.$messages.TITULO_SUCCESS,
                `${messages.headerTituloCertidao} salvo com Sucesso.`
              )
              this.$router.push({
                name: 'LISTAGEM_CERTIDAO',
                query: { tipo: this.despacho.tipo }
              })
            })
        } else {
          if (this.isMaranhao) {
            despacho.tituloDespacho.tituloProcessoDTO.textoCertidao = this.modelTexto.textoTitulo
            despacho.assinaturas = this.imagensAssinaturas
            despacho.isDespachoComAssinaturaSimbolica = true
            if (this.isRetificacaoTitulo) {
              despacho.textoDespacho = ''
              despacho.tituloDespacho.tituloProcesso = JSON.stringify(despacho.tituloDespacho.tituloProcessoDTO)
              this.salvar(despacho)
                .then(() => {
                  this.showNotificacao(
                    this.$messages.TIPO_SUCCESS,
                    this.$messages.TITULO_SUCCESS,
                    `${messages.headerRetificacaoTituloCertidao} salvo com Sucesso.`
                  )
                })
                .catch(e => {
                  this.showNotificacao(
                    this.$messages.TIPO_SUCCESS,
                    this.$messages.TITULO_SUCCESS,
                    `Erro ao salvar o ${messages.headerRetificacaoTituloCertidao}, contate o administrador do sistema.`
                  )
                })
              return
            }
          } else if (this.isAmapa) {
            despacho.tituloDespacho.tituloProcessoDTO.alienacaoDinamica = despacho.tituloDespacho.tituloProcessoDTO.tipoProcesso
            despacho.tituloDespacho.tituloProcessoDTO.tipoProcesso = this.despacho?.processo?.tipo?.codigo
            despacho.tituloDespacho.tituloProcessoDTO.condicaoPagamentoDinamica = despacho.tituloDespacho.tituloProcessoDTO.condicaoPagamento
            despacho.tituloDespacho.tituloProcessoDTO.condicaoPagamento = this.isEstadoAP && this.isNaoOneroso() ? 'Não se aplica' : this.despacho.tituloDespacho.tituloProcessoDTO?.vtnParcelado ? 'Á PRAZO' : 'Á VISTA'
            if (despacho.tituloDespacho.tituloProcessoDTO.portaria.municipios.length) {
              despacho.tituloDespacho.tituloProcessoDTO.portaria.municipios[0].nome = despacho.tituloDespacho.tituloProcessoDTO.portaria.municipio?.nome?.codigo ||
                this.despacho.tituloDespacho.tituloProcessoDTO.portaria.municipio.nome
              despacho.tituloDespacho.tituloProcessoDTO.portaria.municipios[0].codigo = despacho.tituloDespacho.tituloProcessoDTO.portaria.municipio?.nome?.id
              despacho.tituloDespacho.tituloProcessoDTO.portaria.municipios[0].name = undefined
            }
          }
          this.salvar(despacho)
            .then(() => {
              this.showNotificacao(
                this.$messages.TIPO_SUCCESS,
                this.$messages.TITULO_SUCCESS,
                `${messages.headerTituloCertidao} salvo com Sucesso.`
              )
            })
            .catch(e => {
              this.showNotificacao(
                this.$messages.TIPO_SUCCESS,
                this.$messages.TITULO_SUCCESS,
                `Erro ao salvar o ${messages.headerTituloCertidao}, contate o administrador do sistema.`
              )
            })
        }
      }
    },

    cancelar () {
      this.confirmBox(
        `Ao cancelar a ${this.tipoEmissao}, ${this.$messages.CANCELAR_EMISSAO_TITULO_CERTIDAO}`,
        this.$messages.TITULO_WARNING,
        () => {
          this.$router.back()
        },
        () => {}
      )
    },

    tipoDeTitulo () {
      if (this.tipo === 'RETIFICAR_TITULO') {
        this.tipoEmissao = 'Errata do título'
      } else if (this.isTitulo || (this.despacho.tipo === 'TITULO_CERTIDAO' && this.isBahia)) {
        this.tipoEmissao = 'Emissão de título'
      } else {
        this.tipoEmissao = 'Emissão de Certidão de Título'
      }
    },
    mensagemEncaminhar () {
      if (this.isMaranhao && this.isRetificacaoTitulo) {
        const msgEncaminhar = this.action === 'EMITIR' ? 'ENCAMINHAMENTO_ERRATA_TITULO_ASSINATURA' : 'ENCAMINHAMENTO_ERRATA_TITULO_CANCELADA'
        return getMensagemEncaminhamentoTitulo(this.despacho.processo.tipo.codigo,
          msgEncaminhar, this.mensagemConfirmacao, this.acoesRetornarRevisao)
      }
      return getMensagemEncaminhamentoTitulo(this.despacho.processo.tipo.codigo,
        this.despacho.acao, this.mensagemConfirmacao, this.acoesRetornarRevisao)
    },
    async finalizar () {
      if (this.isRevisao || this.isRetorno || !this.despacho.acao) {
        const valido = await this.$refs.validation.validate()
        if (!valido) {
          this.showNotificacao(
            this.$messages.TIPO_WARNING,
            this.$messages.TITULO_WARNING,
            this.$messages.ERROS_ANALISE
          )
          return
        }
      }
      if (!this.isReurb && !this.isMaranhao && !this.isBahia) {
        const valido = await this.$refs.validationTitulo.validate()
        if (!valido) {
          this.showNotificacao(
            this.$messages.TIPO_WARNING,
            this.$messages.TITULO_WARNING,
            this.$messages.ERROS_ANALISE
          )
          return
        }
      }
      const msgEncaminhar = this.mensagemEncaminhar()
      this.confirmBox(
        this.$messages.MSG_CONFIRMACAO,
        this.$messages.TITULO_WARNING,
        () => {
          if (this.isRevisao) {
            this.despacho.tipo = 'REVISAO'
          }
          if (this.isRetorno) {
            this.despacho.tipo = 'DESPACHO'
          }
          if (this.isArquivamentoIndeferimento) {
            this.setCartaNotificacaoInteressado()
            this.cartas = []
          }
          this.finalizarDespacho(this.despacho)
            .then(() => {
              this.showNotificacao(
                this.$messages.TIPO_SUCCESS,
                this.$messages.TITULO_SUCCESS,
                msgEncaminhar
              )
              if ((this.urlOrigem === 'CERTIDAO_LISTAGEM' && (this.isRevisao || this.isRetorno)) || (this.isConferenciaTitulo && this.isMaranhao)) {
                this.$router.push({
                  name: 'EM_ANALISE'
                })
              } else {
                this.$router.push({
                  name: this.urlOrigem
                })
              }
            })
            .catch(error => {
              const erroValidacao = error.status === 422
              const tipoErro = !erroValidacao
                ? this.$messages.TIPO_ERROR
                : this.$messages.TIPO_WARNING
              const tituloErro = !erroValidacao
                ? this.$messages.TITULO_ERROR
                : this.$messages.TITULO_WARNING
              const messagemDeErro =
                Array.isArray(error.erros) && erroValidacao
                  ? error.erros.join(';')
                  : 'Erro ao emitir/conferir Titulo.'
              this.showNotificacao(tipoErro, tituloErro, messagemDeErro)
            })
        },
        () => {}
      )
    },

    async iniciaEmissao () {
      const response = await this.iniciaAnalise({
        idProcesso: this.idProcesso,
        tipoAcao: this.tipo
      })
      this.cartas = response.despacho.anexosCarta
      if (this.isRetificacaoTitulo) {
        this.despacho = {
          ...response.despacho,
          isRetificacaoTitulo: true
        }
        this.modelTexto.textoTitulo = this.despacho.tituloDespacho.tituloProcessoDTO.textoCertidao
      } else if (
        this.despachoEdicao &&
        this.despachoEdicao.tipo === 'TITULO_CERTIDAO'
      ) {
        this.despacho = this.despachoEdicao
      } else {
        this.setDespachoVazio(response)
      }

      if (this.despacho.tituloDespacho.tituloProcessoDTO.portaria) {
        this.despacho.tituloDespacho.tituloProcessoDTO.portaria.municipio = {
          nome: this.despacho.tituloDespacho.tituloProcessoDTO.portaria?.municipios?.[0]?.nome
        }
        this.despacho.tituloDespacho.tituloProcessoDTO.portaria.municipiosFormatadoNome = this.despacho.tituloDespacho.tituloProcessoDTO.portaria?.municipios?.[0]?.nome
      }
      this.dadosCadastro = response.setores
      this.radios = await this.tarefa({ processo: this.idProcesso })
      this.acoesRadio = this.radios.acoes

      if (response?.despacho?.anexosAssinaturasSimbolicas && response?.despacho?.anexosAssinaturasSimbolicas?.length) {
        this.imagensAssinaturas = response?.despacho?.anexosAssinaturasSimbolicas
      }
    },

    setCartaNotificacaoInteressado () {
      if (!this.cartas || !this.cartas.length) {
        return
      }
      this.cartas.forEach(carta => {
        this.despacho.documentos.push(carta)
      })
    },

    setTextoCertidaoTituloProcesso (texto) {
      this.despacho.tituloDespacho.tituloProcesso = JSON.stringify({
        ...JSON.parse(this.despacho.tituloDespacho.tituloProcesso),
        textoCertidao: texto
      })
    },

    async proximo () {
      const despachoSaved = this.active === 0 ? this.$refs.formulario.$refs.tituloCertidao.save() : this.despacho
      if (despachoSaved) {
        if (this.isMaranhao) {
          if (this.isRetificacaoTitulo) {
            this.despacho.textoDespacho = ''
            this.despacho.tituloDespacho.tituloProcessoDTO.textoCertidao = this.modelTexto.textoTitulo
            this.despacho.tituloDespacho.tituloProcesso = JSON.stringify(this.despacho.tituloDespacho.tituloProcessoDTO)
          } else {
            if (this.active === 1) {
              this.despacho.tituloDespacho.tituloProcessoDTO.textoCertidao = this.modelTexto.textoTitulo
            } else {
              this.modelTexto.textoTitulo = this.despacho.tituloDespacho.tituloProcessoDTO.textoCertidao
            }
            this.despacho.assinaturas = this.imagensAssinaturas
            this.despacho.isDespachoComAssinaturaSimbolica = true
          }
        }
        if (this.isAmapa) {
          this.despacho.tituloDespacho.tituloProcessoDTO.alienacaoDinamica = this.despacho.tituloDespacho.tituloProcessoDTO.tipoProcesso
          this.despacho.tituloDespacho.tituloProcessoDTO.tipoProcesso = this.despacho?.processo?.tipo?.codigo
          this.despacho.tituloDespacho.tituloProcessoDTO.condicaoPagamentoDinamica = this.despacho.tituloDespacho.tituloProcessoDTO.condicaoPagamento
          this.despacho.tituloDespacho.tituloProcessoDTO.condicaoPagamento = this.isEstadoAP && this.isNaoOneroso() ? 'Não se aplica' : this.despacho.tituloDespacho.tituloProcessoDTO?.vtnParcelado ? 'Á PRAZO' : 'Á VISTA'
          if (this.despacho.tituloDespacho.tituloProcessoDTO.portaria.municipios.length) {
            this.despacho.tituloDespacho.tituloProcessoDTO.portaria.municipios[0].nome = this.despacho.tituloDespacho.tituloProcessoDTO.portaria.municipio?.nome?.codigo ||
              this.despacho.tituloDespacho.tituloProcessoDTO.portaria.municipio.nome
            this.despacho.tituloDespacho.tituloProcessoDTO.portaria.municipios[0].codigo = this.despacho.tituloDespacho.tituloProcessoDTO.portaria.municipio?.nome?.id
            this.despacho.tituloDespacho.tituloProcessoDTO.portaria.municipios[0].name = undefined
          }
        }

        const despachoSalvo = await this.salvar(this.despacho)

        if (this.isRetificacaoTitulo && this.isMaranhao) {
          const arraybufferTitulo = await this.getArrayRetificacaoTituloByDespachoId(
            despachoSalvo.id
          )

          this.despacho.id = despachoSalvo.id

          this.bytes = arraybufferTitulo
        } else if ((this.isMaranhao && this.active === 1) || (!this.isMaranhao && this.active === 0)) {
          const arraybufferTitulo = await this.getArrayTituloByDespachoId(
            despachoSalvo.id
          )
          this.despacho.id = despachoSalvo.id
          this.bytes = arraybufferTitulo
        }
        this.active++
      } else {
        // Fazer aqui algum tipo de retorno para caso dê errado as validações
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          'Para finalizar a análise preencha todos os campos destacados.'
        )
      }
    },
    async voltar () {
      await this.iniciaEmissao()
      this.active = 0
    },

    downloadPdf () {
      FileHelper.saveFile(
        this.bytes,
        this.despacho.tipo === 'ERRATA_TITULO'
          ? 'minuta da errata'
          : this.despacho.processo.tipo.codigo === 'CERTIDAO_TITULO'
            ? 'minuta da certidão'
            : 'minuta do título'
      )
    },

    uploadCartaNotificacao (file) {
      this.cartas.push({
        key: file.response,
        nome: file.name,
        tipo: {
          id: 341,
          codigo: 'CARTA_NOTIFICACAO_INTERESSADO'
        }
      })
    },

    removeCartaNotificacao (documento) {
      const index = this.cartas.indexOf(
        this.cartas.find(m => m.key === documento.key)
      )
      this.cartas.splice(index, 1)
    },

    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    },

    changeRadio (value) {
      this.despacho.acao = value.acao
    },

    changeRadioDespacho (value) {
      this.despacho.acao = null
      if (value.acao === 'REVISAO') {
        this.acoesRadio = this.acoesRadio.filter(a => !a.valor.includes('CONFERENCIA'))
      } else {
        this.acoesRadio = this.radios.acoes
      }
      this.action = value.acao
    },

    onTextChange (text) {
      this.despacho.textoDespacho = text
    },

    onTextChangeTitulo (text) {
      this.modelTexto.textoTitulo = text
    },

    uploadFile (file) {
      this.despacho.documentos.push({
        key: file.response,
        nome: file.name,
        tipo: {
          id: 51,
          codigo: 'ANEXO_ANALISE'
        }
      })
    },

    uploadAssinatura (file) {
      if (this.imagensAssinaturas.length < 6) {
        this.imagensAssinaturas.push({
          key: file.response,
          nome: file.name,
          tipo: {
            id: 343,
            codigo: 'ASSINATURA_SIMBOLICA'
          }
        })
      } else {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'É permitido no máximo 6 assinaturas!')
      }
    },

    removeAssinatura (documento) {
      this.confirmBox(
        this.$messages.DOCUMENTO_REMOVE_CONFIRM,
        this.$messages.TITULO_WARNING,
        () => {
          const index = this.imagensAssinaturas.indexOf(
            this.imagensAssinaturas.find(a => a.id === documento.id)
          )
          this.imagensAssinaturas.splice(index, 1)
        },
        () => {}
      )
    },

    async removeFile (documento) {
      this.confirmBox(
        this.$messages.DOCUMENTO_REMOVE_CONFIRM,
        this.$messages.TITULO_WARNING,
        () => {
          this.deleteAnexo(documento)
        },
        () => {}
      )
    },

    deleteAnexo (documento) {
      if (documento.id) {
        const index = this.despacho.documentos.indexOf(
          this.despacho.documentos.find(a => a.id === documento.id)
        )
        this.despacho.documentos.splice(index, 1)
      } else {
        const index = this.despacho.documentos.indexOf(
          this.despacho.documentos.find(a => a.key === documento.key)
        )
        this.despacho.documentos.splice(index, 1)
      }
    },

    downloadDocumentoCadastro (documento) {
      this.getDownload(documento)
    },

    setDespachoVazio (response) {
      if (response.despacho.status !== 'FINALIZADO') {
        this.despacho = response.despacho
      } else {
        this.despacho = {
          ...response.despacho,
          textoDespacho: '',
          documentos: [],
          processo: response.despacho.processo,
          id: null,
          numeroDaCertidao: null,
          tituloDespacho: { tituloProcesso: null, tituloProcessoDTO: {} }
        }
      }
    },
    filtrarDocumentosSemAssinaturaSimbolicaMa () {
      if (this.isMaranhao) {
        return this.despacho.documentos.filter(doc => doc.tipo.codigo !== 'ASSINATURA_SIMBOLICA')
      } else {
        return this.despacho.documentos
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.margin {
  margin-top: 25px;
}
.flex {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.flex-around {
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.input-text-editor {
  margin-top: 30px;
}
.button-style {
  display: flex;
  flex-direction: row;
}
.labelAssinatura {
  font-family: sans-serif;
  font-size: 14px;
  margin: 250px;
  font-weight: bold;
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/EmissaoTituloCertidao.vue